import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  genders: [],
  dailys: [],
  facultys: [],
  regions: [],
  passeds: [],
  paids: [],
});

export const mutations = {
  SET_GENDERS(state, payload) {
    state.genders = vm.$toArray(payload);
  },

  SET_DAILYS(state, payload) {
    state.dailys = vm.$toArray(payload);
  },

  SET_FACULTYS(state, payload) {
    state.facultys = vm.$toArray(payload);
  },

  SET_REGIONS(state, payload) {
    state.regions = vm.$toArray(payload);
  },

  SET_PASSEDS(state, payload) {
    state.passeds = vm.$toArray(payload);
  },

  SET_PAIDS(state, payload) {
    state.paids = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_GENDERS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get(`admin/statistics/gender`);

    status = data != null;
    commit("SET_GENDERS", data);

    return status;
  },

  async INIT_DAILYS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get(`admin/statistics/daily`);

    status = data != null;
    commit("SET_DAILYS", data);

    return status;
  },

  async INIT_FACULTYS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get(`admin/statistics/faculty`);

    status = data != null;
    commit("SET_FACULTYS", data);

    return status;
  },

  async INIT_REGIONS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get(`admin/statistics/regional`);

    status = data != null;
    commit("SET_REGIONS", data);

    return status;
  },

  async INIT_PASSEDS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get("admin/statistics/passed");

    status = data != null;
    commit("SET_PASSEDS", data);

    return status;
  },

  async INIT_PAIDS({ commit }) {
    let status = false;
    const data = await vm.$axios.$get("admin/statistics/paid");

    status = data != null;
    commit("SET_PAIDS", data);

    return status;
  },
};

export const getters = {
  GET_GENDERS: (state) => state.genders,
  GET_DAILYS: (state) => state.dailys,
  GET_FACULTYS: (state) => state.facultys,
  GET_REGIONS: (state) => state.regions,
  GET_PASSEDS: (state) => state.passeds,
  GET_PAIDS: (state) => state.paids,
};
